export default __webpack_public_path__ + "static/media/loading_icon.1a32f552.gif";